<template>
  <div class="bxp-recaptcha-wrapper">
    <div id='recaptcha' class="g-recaptcha"
      data-sitekey="6Lf9F9IUAAAAAPkfJYQne_0BmqAt_S98vbfCtCGb"
      data-callback="bxpRecaptchaCallback"
      data-size="invisible">
    </div>
    <div class="bxp-recaptcha-text">
      <p>
        This site is protected by reCAPTCHA and the Google
        <a target="_blank" href="https://policies.google.com/privacy">Privacy Policy</a> and
        <a target="_blank" href="https://policies.google.com/terms">Terms of Service</a> apply.
      </p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  beforeCreate() {
    let recaptchaScript = document.createElement('script') 
    recaptchaScript.setAttribute('src', "https://www.google.com/recaptcha/api.js")
    recaptchaScript.setAttribute('async', true)
    recaptchaScript.setAttribute('defer', true)
    document.head.appendChild(recaptchaScript)
    
    //Emit an event when the recaptcha has been executed
    window.bxpRecaptchaCallback = function(token) {
      var event = new Event('recaptchaCompleted');
      document.dispatchEvent(event);
    }
    
  }
}
</script>

<style>

  .bxp-recaptcha-wrapper {
    display: block;
    width: 100%;
  }

  .bxp-recaptcha-text {
    text-align: center;
  }
  .bxp-recaptcha-text p {
    font-size: 12px;
  }

  @media (max-width: 1032px) {
    .bxp-recaptcha-text p {
      font-size: 10px;
    }
  }

  /* Hide the default recaptcha badge */
  .grecaptcha-badge { 
    display: none !important; 
  }

</style>
